import { useCallback, useState } from 'react';
import { AModal } from '../Modal';
import { Form, Input } from 'antd';
import { useToast } from '../../hooks/toast';
import { useConfiguration } from '../../hooks/configuration';
import api from '../../services/api';
import { hasAllowedModule } from '../../shared/utils/modules';
import { useI18n } from '../../shared/i18n';

interface IToSignatureProps {
  open: boolean;
  close: () => void;
  setSignature?: React.Dispatch<React.SetStateAction<string | null>>;
  professional_id: string | null | undefined;
  onAuthenticated?: (authData: any, password: string) => Promise<void> | void;
}
export const ToSignature: React.FC<IToSignatureProps> = ({
  open,
  close,
  setSignature,
  professional_id,
  onAuthenticated,
}) => {
  const { addToast } = useToast();
  const { t } = useI18n();
  const { configuration } = useConfiguration();
  const [password, setPassword] = useState<string>();
  const canUseDigitalSignature = hasAllowedModule(
    configuration?.allowed_modules,
    'assinatura_digital',
  );

  const handleSign = useCallback(async () => {
    if (!password) {
      addToast({
        type: 'warning',
        title: t('toSignature.toast.warningTitle'),
        description: t('toSignature.toast.passwordRequired'),
      });
      return;
    }
    await api
      .post('/professionals/to_sign', {
        professional_id,
        password,
      })
      .then(async (response) => {
        if (setSignature) {
          setSignature(response.data.signature);
        }
        if (onAuthenticated) {
          await onAuthenticated(response.data, password);
        }
        setPassword(undefined);
        close();
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: t('toSignature.toast.errorTitle'),
          description: `${error.response.data.message}`,
        });
      });
  }, [
    password,
    professional_id,
    setSignature,
    onAuthenticated,
    close,
    addToast,
    t,
  ]);

  if (!open || !canUseDigitalSignature) return <></>;

  return (
    <AModal
      open={open}
      close={close}
      title={t('toSignature.title')}
      onOk={handleSign}
    >
      <Form layout="vertical" style={{ margin: '12px 0px' }}>
        <Form.Item label={t('toSignature.fields.password')}>
          <Input.Password
            placeholder={t('toSignature.fields.passwordPlaceholder')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Item>
      </Form>
    </AModal>
  );
};
